<template>
    <div class="components-container">
        <div v-if="auditFlowInfo" class="auditFlow">
            <el-steps :active="auditFlowInfo.stepIndex" finish-status="success">
                <el-step v-for="(item, index) in auditFlowInfo.auditSteps" :key="index" :title="item.title" :description="item.desc" :status="item.status"></el-step>
            </el-steps>
        </div>
        <div :style="{marginBottom: marginBottomHeight + 'px'}">
            <el-select v-model="queryForm.state" filterable placeholder="请选择状态" style="width:200px;">
                <el-option v-for="item in comboData.state" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-button @click="handleFilter" type="gray" size="medium" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray" size="medium"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
        </div>

        <el-table :data="tableData" v-loading.body="tableLoading" element-loading-text="信息加载中" :cell-style="handleCellStyle"
            highlight-current-row stripe border fit style="width: 100%" :height="mainTableHeight" ref="mainTable">
            <el-table-column label="审核层级" prop="auditLevel" align="center" min-width="15%"></el-table-column>
            <el-table-column label="审核状态" prop="auditState" align="center"min-width="15%"></el-table-column>
            <el-table-column label="审核意见" prop="opinion" align="center"></el-table-column>
            <el-table-column label="审核人" prop="auditor" align="center" min-width="18%"></el-table-column>
            <el-table-column label="审核时间" prop="auditTime" align="center" min-width="18%"></el-table-column>
            <el-table-column label="状态" prop="state" align="center" min-width="12%"></el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        props: ['relatedCode', 'listHeight', 'auditFlowInfo'],
        data() {
            return {
                comboData: {
                    state: null,
                },
                mainTableHeight: 400,
                queryForm: {
                    relatedCode: null,
                    state: null,
                },
                tableData: [],
                tableLoading: false,
                marginBottomHeight: 20,
            };
        },
        mounted() {
            this.queryForm.relatedCode = this.relatedCode;
            this.initCombo();
            this.queryList();

            this.$nextTick().then(() => {
                if(this.listHeight){
                    this.mainTableHeight = this.listHeight;
                }

                if(this.auditFlowInfo){
                    this.mainTableHeight = this.mainTableHeight - 100;
                    this.marginBottomHeight = 10;
                }
            });
        },
        methods: {
            initCombo() {
                this.$api.common.comboOption.common({
                    data: { type:'YXZT' }
                }).then((res) => {
                    this.comboData.state = res.data.data.comboData;
                }).catch((err) => {
                    console.log(err);
                });
            },
            handleFilter() {
                this.queryList();
            },
            handleReset() {
                this.queryForm.state = null;
                this.tableLoading = false;
                this.queryList();
            },
            queryList() {
                this.tableLoading = true;
                this.$api.common.audit.list({
                    data: this.queryForm,
                }).then((response) => {
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            handleCellStyle({row, column, rowIndex, columnIndex}){
                let cellStyle;

                if(columnIndex === 1){
                    switch (row.auditState) {
                        case '通过':
                            cellStyle = 'color: #00FF40 !important;';
                            break;
                        case '驳回':
                            cellStyle = 'color: #FE2E2E !important;';
                            break;
                        default:
                            cellStyle = '';
                    }

                    return cellStyle;
                }
            },
        },
    };
</script>
<style scoped>
    .auditFlow {
        width: 100%;
        height: 100px;
        margin-top: -20px;
        margin-bottom: 10px;
        padding: 10px;
        overflow: auto;
    }
</style>



// WEBPACK FOOTER //
// auditList.vue?08cf526a